import { render, staticRenderFns } from "./StorageInformation.vue?vue&type=template&id=718bd2a9&scoped=true&"
import script from "./StorageInformation.vue?vue&type=script&lang=js&"
export * from "./StorageInformation.vue?vue&type=script&lang=js&"
import style0 from "./StorageInformation.vue?vue&type=style&index=0&id=718bd2a9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718bd2a9",
  null
  
)

export default component.exports